import script from "./pop-up-intro.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-up-intro.vue?vue&type=script&setup=true&lang=js"

import "./pop-up-intro.vue?vue&type=style&index=0&id=09ff8a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ff8a1a"]])

export default __exports__